import React from 'react';

export function useImmutableRef<T>(initializer: () => T): T {
    const ref = React.useRef<T | null>(null);
    if (ref.current === null) {
        ref.current = initializer();
    }
    return ref.current!;
}